export const WindowCloseLineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g id="clarity:window-close-line">
        <path
          id="Vector"
          d="M8.62676 8L11.8668 4.76C11.9396 4.67498 11.9776 4.56561 11.9733 4.45375C11.969 4.3419 11.9226 4.23579 11.8435 4.15664C11.7643 4.07748 11.6582 4.03111 11.5463 4.02679C11.4345 4.02247 11.3251 4.06052 11.2401 4.13333L8.0001 7.37333L4.7601 4.12889C4.67507 4.05608 4.56571 4.01803 4.45385 4.02235C4.34199 4.02667 4.23589 4.07304 4.15674 4.15219C4.07758 4.23135 4.03121 4.33745 4.02689 4.44931C4.02257 4.56116 4.06062 4.67053 4.13343 4.75555L7.37343 8L4.12899 11.24C4.08246 11.2798 4.04467 11.3289 4.018 11.384C3.99132 11.4392 3.97633 11.4992 3.97396 11.5604C3.9716 11.6216 3.98191 11.6827 4.00426 11.7397C4.0266 11.7967 4.06049 11.8485 4.10381 11.8918C4.14712 11.9352 4.19892 11.969 4.25595 11.9914C4.31299 12.0137 4.37402 12.024 4.43523 12.0217C4.49644 12.0193 4.5565 12.0043 4.61164 11.9777C4.66678 11.951 4.71581 11.9132 4.75565 11.8667L8.0001 8.62667L11.2401 11.8667C11.3251 11.9395 11.4345 11.9775 11.5463 11.9732C11.6582 11.9689 11.7643 11.9225 11.8435 11.8434C11.9226 11.7642 11.969 11.6581 11.9733 11.5462C11.9776 11.4344 11.9396 11.325 11.8668 11.24L8.62676 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
